// Filtro best-effort de nicks ofensivos, para dar feedback inmediato al elegir el nombre.
// La AUTORIDAD es el backend (lib/timba.php::timba_is_offensive); esto es solo UX.
const BADWORDS = [
  'puto', 'puta', 'putito', 'putita', 'putos', 'putas', 'concha', 'conchud', 'pelotud',
  'forro', 'choto', 'garca', 'trolo', 'trola', 'cagon', 'mierda', 'carajo', 'pendej',
  'sorete', 'maricon', 'travesti', 'violador', 'pedofil', 'culiad', 'culiao', 'chupame',
  'chupala', 'reconcha', 'requeteputa', 'nazi', 'hitler', 'mongolic', 'mogolic', 'retardad',
  'subnormal', 'fuck', 'shit', 'bitch', 'cunt', 'nigger', 'faggot', 'asshole', 'pussy', 'whore',
];

// Minúsculas, sin acentos, leet básico (0→o, 1→i, 3→e, 4→a, 5/$→s, 7→t, @→a) y solo letras a-z.
function normalize(s: string): string {
  return s
    .toLowerCase()
    .normalize('NFD').replace(new RegExp('[\\u0300-\\u036f]', 'g'), '') // saca acentos
    .replace(/0/g, 'o').replace(/1/g, 'i').replace(/3/g, 'e').replace(/4/g, 'a')
    .replace(/[5$]/g, 's').replace(/7/g, 't').replace(/@/g, 'a')
    .replace(/[^a-z]/g, '');
}

export function isOffensive(s: string): boolean {
  const n = normalize(s);
  return !!n && BADWORDS.some((w) => n.includes(w));
}
